import { api } from '@creditsights/api-ui-web';
import { flatten } from 'lodash';
import { CaseDocumentsQueryFilters } from '../../hooks/dockets/useFetchCaseDocuments';
import { DocketItemDto, DocketsDto, DocketsListDto, DownloadItemResponse } from '../dtos/companyDockets/dockets.dto';

const DEFAULT_DOCUMENTS_SORT = 'docketItemNumber';
const ATTACHMENT_PAGE_SIZE = 250;

const BASE_URI = 'common/v1/dockets';
export const getCasesUri = (companyId: string): string => `${BASE_URI}/cases?companyId=${companyId}`;
export const getCaseDocketsUri = (docketCaseId: number): string => `${BASE_URI}/cases/${docketCaseId}/dockets`;
export const getDocumentAttachmentsUri = (docketCaseId: number, page: number, date: string): string =>
  `${BASE_URI}/cases/${docketCaseId}/documents?pageIndex=${page}&pageSize=${ATTACHMENT_PAGE_SIZE}&itemFiledFromDate=${date}&itemFiledToDate=${date}`;
export const getDownloadDocketItemUri = (docketCaseId: number, docketItemId: number): string =>
  `${BASE_URI}/cases/${docketCaseId}/documents/${docketItemId}/download`;
export const getDownloadJobStatusUri = (requestId: string): string => `${BASE_URI}/download-status/${requestId}`;

export const fetchCases = async (companyId: string): Promise<DocketsDto[]> => {
  const { data } = await api.get<DocketsDto[]>(getCasesUri(companyId));
  return data;
};

export const fetchCaseDocuments = async (
  docketCaseId: number,
  { page, take, keyFilings }: { page: number; take: number; keyFilings: boolean },
  filters: CaseDocumentsQueryFilters
): Promise<DocketsListDto> => {
  const { data } = await api.post<DocketsListDto>(getCaseDocketsUri(docketCaseId), {
    sortBy: DEFAULT_DOCUMENTS_SORT,
    searchText: filters?.keyword,
    itemFiledFromDate: filters?.itemFiledFromDate,
    itemFiledToDate: filters?.itemFiledToDate,
    pageIndex: page,
    pageSize: take,
    keyFilings,
  });
  return data;
};

export const fetchDocumentAttachments = async (docketCaseId: number, date: string): Promise<DocketItemDto[]> => {
  const { data } = await api.get<DocketsListDto>(getDocumentAttachmentsUri(docketCaseId, 0, date));

  if (data.page.totalPages <= 1) {
    return data.docketItemList;
  }

  const docketItems = await Promise.all(
    Array(data.page.totalPages - 1)
      .fill(0)
      .map((_, index) => api.get<DocketsListDto>(getDocumentAttachmentsUri(docketCaseId, index + 1, date)))
  );

  return [...data.docketItemList, ...flatten(docketItems.map((item) => item.data.docketItemList))];
};

export const downloadDocketItem = async (docketCaseId: number, docketItemId: number): Promise<DownloadItemResponse> => {
  const { data } = await api.post(getDownloadDocketItemUri(docketCaseId, docketItemId));
  return data;
};

export const getDownloadJobStatus = async (requestId: string): Promise<DownloadItemResponse> => {
  const { data } = await api.get(getDownloadJobStatusUri(requestId));
  return data;
};
